<ng-container *ngIf="(shoppingCartService.itemsTotalsChanged | async) as totals">

  <button mat-raised-button [routerLink]="link ? link : null" [disableRipple]="!link" class="cart mat-elevation-z0" [ngClass]="
  {
    warn: totals.weightPercent >= 50 && totals.weightPercent < 90,
    full: totals.weightPercent >= 90 && totals.weightPercent <= 100,
    error: totals.weightPercent > 100,
    static: !link
  }">
    <span class="fill" [style.height]="totals.weightPercentTruck + 'px'"></span>
    <span class="counter">{{totals.weightPercent}}%</span>
  </button>

</ng-container>
